var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-page",on:{"click":_vm.logoGlow}},[_c('img',{class:{
      'is-glowing': _vm.currentStep === 'glow',
      'is-scaling': _vm.currentStep === 'scale'
      },style:({
      '--glow-duration': _vm.DURATION.GLOW,
      '--scale-duration': _vm.DURATION.SCALE
      }),attrs:{"src":_vm.logoSrc},on:{"animationend":_vm.onAnimationEnd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }